export default {
	getMessage: field => 'The ' + field + ' value is not truthy.',
	validate: value => !! value
}


// WEBPACK FOOTER //
// ./src/rules/vee-validate/authorize.js